import { render, staticRenderFns } from "./TabFrameMinimal.vue?vue&type=template&id=10c79515&"
import script from "./TabFrameMinimal.vue?vue&type=script&lang=js&"
export * from "./TabFrameMinimal.vue?vue&type=script&lang=js&"
import style0 from "./TabFrameMinimal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports